// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"93efa75e","776":"21c2cc28","868":"8a3b3a28"}[chunkId] + ".chunk.css";
};